// extracted by mini-css-extract-plugin
module.exports = {"darkGradient":"filters_darkGradient__nrxVD"};